import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Box } from "@mui/material";
import VehicleSOAList from "pages/Dashboard/ReportingAnalytics/VehicleSOAList";
import { setStoredUser } from "auth/authStorage";

// Render-only host for the Vehicle SOA WhatsApp cron.
// Backend's puppeteer loads /print/vehicle-soa?customer_id=X&customer_name=N
// &customer_ref_id=R&render_token=Y, then waits for window.__SOA_READY__
// before reading the kendo-generated PDF data URI off the window object.
//
// Vehicle SOA's customer dropdown is search-based (no preloaded list), so
// the backend passes name + ref_id explicitly — the page synthesizes the
// selectedCustomer object instead of trying to find it in the dropdown.
function VehicleSoaPrint() {
  const [params] = useSearchParams();
  const [seeded, setSeeded] = useState(false);

  const customerId = params.get("customer_id");
  const customerName = params.get("customer_name") || "";
  const customerRefId = params.get("customer_ref_id") || "";
  const customerPhone = params.get("customer_phone") || "";
  const renderToken = params.get("render_token");

  useEffect(() => {
    if (!customerId || !renderToken) return;
    setStoredUser({
      id: 0,
      token: renderToken,
      user_type: "A",
      name: "soa-render",
    });
    setSeeded(true);
  }, [customerId, renderToken]);

  if (!customerId || !renderToken) {
    return (
      <Box sx={{ p: 4, fontFamily: "Arial, sans-serif" }}>
        Missing customer_id or render_token in URL.
      </Box>
    );
  }
  if (!seeded) {
    return (
      <Box sx={{ p: 4, fontFamily: "Arial, sans-serif" }}>Initializing…</Box>
    );
  }

  return (
    <VehicleSOAList
      printMode
      printCustomerId={customerId}
      printCustomerName={customerName}
      printCustomerRefId={customerRefId}
      printCustomerPhone={customerPhone}
      printFromDate={params.get("from_date") || undefined}
      printToDate={params.get("to_date") || undefined}
    />
  );
}

export default VehicleSoaPrint;
